import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-space-between align-center text-center bg-white mt-2",
  style: {"width":"100%"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "text-caption font-weight-bold"
}
const _hoisted_4 = { class: "text-h6 font-weight-bold" }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        variant: "text",
        color: "primary",
        class: "navigation-button",
        onClick: _ctx.subtractDay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          }),
          (_ctx.beforeTheDate > 0)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 0,
                color: "primary",
                content: `${_ctx.beforeTheDate}`,
                inline: ""
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" 前日 ", -1)
                ]))]),
                _: 1
              }, 8, ["content"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, " 前日 "))
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isYear)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.todayYear), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.todayDate) + " (" + _toDisplayString(_ctx.todayDayWeek) + ")", 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        variant: "text",
        color: "primary",
        class: "navigation-button",
        onClick: _ctx.addDay
      }, {
        default: _withCtx(() => [
          (_ctx.afterTheDate > 0)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 0,
                color: "primary",
                content: `${_ctx.afterTheDate}`,
                inline: ""
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 翌日 ", -1)
                ]))]),
                _: 1
              }, 8, ["content"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, " 翌日 ")),
          _createVNode(_component_v_icon, { end: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}